"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfigBySearchProfile = exports.getSearchProfileByLocale = exports.config = void 0;
var markets_json_1 = __importDefault(require("./markets.json"));
exports.config = markets_json_1.default;
function getSearchProfileByLocale(locale) {
    return locale ? exports.config[locale].sp : exports.config.en_GB.sp;
}
exports.getSearchProfileByLocale = getSearchProfileByLocale;
var getConfigBySearchProfile = function (sp) {
    var configMap = new Map();
    Object.entries(exports.config).forEach(function (_a) {
        var index = _a[0], value = _a[1];
        configMap.set(value.sp, __assign({ language: index.split('_')[0], market: index.split('_')[1] }, value));
    });
    var marketConfig = configMap.get(sp);
    if (!marketConfig) {
        throw new Error("No matching market config found with provided search profile \"".concat(sp, "\""));
    }
    return {
        market: marketConfig.market,
        language: marketConfig.language,
        locale: "".concat(marketConfig.language, "_").concat(marketConfig.market),
    };
};
exports.getConfigBySearchProfile = getConfigBySearchProfile;
